import { NOTIFICATION_TYPES } from '@/common/constants/notifications.constants';
import { Notification } from '@uikit/ui-kit';
import { useNotificationsStore, type NotificationItem } from '@/common/store/pinia/notifications';
import type { ElNotification } from '@uikit/ui-kit/types/notification';

type Notify = ElNotification
  & ((options: Partial<NotificationItem>) => ElNotification | Promise<unknown> | void)
  & {
    update: (notification: Partial<NotificationItem>) => void
  };

let $notify: Notify;

const getNotify = (): Notify => {
  if ($notify) return $notify;

  const notificationsStore = useNotificationsStore();

  const notify = function (options: Partial<NotificationItem>) {
    if (options.skipStore) return Notification(options);
    return notificationsStore.addOrUpdate(options);
  };

  $notify = Object.assign(
    notify,
    Notification,
    { update: notificationsStore.update }
  );

  NOTIFICATION_TYPES.forEach((type) => {
    $notify[type] = ({ skipStore, ...options }) => {
      if (skipStore) return Notification[type](options);
      return notificationsStore.addOrUpdate({ ...options, type });
    };
  });

  return $notify;
};

export default {
  install(app) {
    app.prototype.$notify = getNotify();
  }
};

export function useNotifications() {
  return {
    notify: getNotify()
  };
}
